// extracted by mini-css-extract-plugin
module.exports = {"loadingLayer":"loading-layer_loadingLayer__DQH_E","shimmer":"loading-layer_shimmer__Q8StF"};